export const trendClass = (trend) => {
  if (trend === "increased") return "kdb-odds-value--up";
  if (trend === "decreased") return "kdb-odds-value--down";
  return "";
};

export const hasTrend = (trend) =>
  trend === "increased" || trend === "decreased";
